/*
 *  Licensed under the EUPL, Version 1.2 or – as soon they will be approved by
the European Commission - subsequent versions of the EUPL (the "Licence");
You may not use this work except in compliance with the Licence.
You may obtain a copy of the Licence at:

  https://joinup.ec.europa.eu/software/page/eupl

Unless required by applicable law or agreed to in writing, software
distributed under the Licence is distributed on an "AS IS" basis,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the Licence for the specific language governing permissions and
limitations under the Licence. */

import SvgIcon from "@mui/material/SvgIcon";

const WalkingSurfaceIndicatorsAll = (props) => (
  <SvgIcon
    {...props}
    width="225.000000pt"
    height="225.000000pt"
    viewBox="0 0 20.62 13.58"
    enableBackground="new 0 0 100 100"
    preserveAspectRatio="xMidYMid meet"
  >
    <g id="Layer_1-2" data-name="Layer 1" focusable="false">
      <path d="M0,0v13.58h20.62V0H0ZM5.53,12.06H1.5v-1.8h4.03v1.8ZM5.53,7.65H1.5v-1.8h4.03v1.8ZM5.53,3.23H1.5v-1.8h4.03v1.8ZM10.06,12.06h-4.03v-1.8h4.03v1.8ZM10.06,7.65h-4.03v-1.8h4.03v1.8ZM10.06,3.23h-4.03v-1.8h4.03v1.8ZM14.59,12.06h-4.03v-1.8h4.03v1.8ZM14.59,7.65h-4.03v-1.8h4.03v1.8ZM14.59,3.23h-4.03v-1.8h4.03v1.8ZM19.12,12.06h-4.03v-1.8h4.03v1.8ZM19.12,7.65h-4.03v-1.8h4.03v1.8ZM19.12,3.23h-4.03v-1.8h4.03v1.8Z" />
    </g>
  </SvgIcon>
);
export default WalkingSurfaceIndicatorsAll;
